<rask-radiobutton-group label="Violversion" [buttons]="activetypes" [(ngModel)]="violVersion" (change)="changeViolversion()" [disabled]="disabled" (change)="changeVersion($event)"></rask-radiobutton-group>
